import {
  getReadProvider,
  OChainId,
  TChainId,
  VAULT_CONTRACT,
} from 'modules/api';
import { getExtendedErrorText } from 'modules/common/utils/getExtendedErrorText';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { CommonCacheTags, web3Api } from 'store/web3Api';

import { VAULT_ABI } from './abi';
import { fromSatoshi } from 'modules/api/utils/convertSatoshi';
import BigNumber from 'bignumber.js';

export async function getTotalVaultSupply(chainId: TChainId): Promise<number> {
  const provider = await getReadProvider(chainId);

  const vaultContract = provider.createContract(VAULT_ABI, VAULT_CONTRACT);

  // returns total supply lbtc + ebtc
  const balance: bigint = await vaultContract.methods.totalSupply().call();

  return fromSatoshi(balance.toString());
}

export const { useGetLbtcVaultSupplyQuery } = web3Api.injectEndpoints({
  endpoints: build => ({
    getLbtcVaultSupply: build.query<BigNumber, void>({
      queryFn: queryFnNotifyWrapper<void, never, BigNumber>(
        async () => {
          const totalLbtcEthSupply = await getTotalVaultSupply(
            OChainId.ethereum,
          );

          const totalLbtcSonicSupply = await getTotalVaultSupply(
            OChainId.sonic,
          );

          return {
            data: new BigNumber(totalLbtcEthSupply).plus(totalLbtcSonicSupply),
          };
        },
        error => getExtendedErrorText(error, 'Unable to get LBTC vault supply'),
      ),
      providesTags: [CommonCacheTags.lbtcVaultBalance],
    }),
  }),
});
